<template>
  <v-container>
    <v-btn
      class="mt-n3 text_white--text text-capitalize me-1"
      :disabled="stockList.length == 0"
      @click="exportExcel"
      width="150"
      color="secondary"
    >
      <v-icon color="text_white">mdi-export</v-icon>Export
    </v-btn>

    <div v-show="false">
      <v-data-table
        id="printCurrentStock"
        hide-default-footer
        :items-per-page="-1"
        :headers="headers"
        :items="stockListAll"
        class="elevation-1 mt-6"
      >
        <template v-slot:item.quantity="{ item }">
          <span v-if="item.quantityUnit == 'PIECE'">
            {{ parseFloat(item.stock.currentStock).toFixed(0) }}&nbsp;{{
              itemQuantityUnit(item)
            }}
          </span>
          <span v-else>
            {{ parseFloat(item.stock.currentStock / 1000).toFixed(3) }}&nbsp;{{
              itemQuantityUnit(item)
            }}
          </span>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>
<script>
import { Utils } from "../../../utils/utils";
export default {
  props: {
    stockList: {
      require: true
    },
    headers: {
      require: true
    }
  },
  // watch: {
  //   stockList: {
  //     handler() {
  //       this.getAllStocks();
  //     },
  //     deep: true,
  //   },
  // },
  created() {
    
  },
  methods: {
    exportExcel() { 
      this.loading=false
      this.getAllStocks();
    },
    itemQuantityUnit(item) {
      let unit = "";
      if (item.quantityUnit === "GRAMS") unit = "KG";
      else if (item.quantityUnit === "ML") unit = "L";
      else if (item.quantityUnit === "PIECE") unit = "PCS";
      return unit;
    },
    getAllStocks() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../../api/getAllCurrentStocks.graphql"),
          variables: {
            limit: 0,
            skip: 0
          }
        })
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(data => {
          if (data.data.getAllCurrentStocks) {
            this.stockListAll = data.data.getAllCurrentStocks.ingredients;
            setTimeout(() => {
              Utils.htmlToExcel("printCurrentStock", "Ingredient", false);
            }, 100);
            this.loading = false;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    }
  },
  data() {
    return {
      loading: true,
      stockListAll: []
    };
  }
};
</script>
